import { Button, Col, Row, Space, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { clsx } from "clsx";
import { GroupSetting } from "../../../../common/components/GroupSetting";
import { NotificationSetting } from "../../../../common/components/NotificationSetting";
import { OrderForm } from "../../../../types/OrderFormTypes";
import { ResourceType } from "../../../../types/ResourceType";
import { Vendor } from "../../../../types/VendorTypes";
import { Supplier } from "../../../../types/SupplierTypes";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { getVendors } from "../../../../common/api/VendorClient";
import { GenericCard } from "../../../../common/components/GenericCard";
import { getSupplierByName } from "../../../../common/api/SupplierClient";
import { OrderFormTable } from "./OrderFormTable";
import classes from "./OrderFormTablePanel.module.less";

interface OrderFormTablePanelProps {
    orderFormId: number;
    orderForm: OrderForm;
    disabled?: boolean;
    onChange?: (orderForm: OrderForm) => void;
    showExpand?: boolean;
    onExpand?: () => void;
}

export const OrderFormTablePanel: React.FC<OrderFormTablePanelProps> = ({
    orderFormId,
    orderForm,
    onChange,
    disabled,
    showExpand,
    onExpand,
}) => {
    const [vendor, setVendor] = useState<Vendor>();
    const [supplier, setSupplier] = useState<Supplier>();
    const loadVendor = async () => {
        if (orderForm.vendorKey) {
            const res = await getVendors([orderForm.vendorKey]);
            setVendor(res[0]);

            const vendorName = res[0]?.name;
            if (vendorName) {
                const supplier = await getSupplierByName(vendorName);
                setSupplier(supplier);
            }
        }
    };

    useEffect(() => {
        loadVendor();
    }, [orderForm]);

    return (
        <GenericCard size="mini">
            <Row align="middle" className={classes.header}>
                <Col className={clsx(classes.expander, !showExpand && classes.hidden)}>
                    <Button type="primary" icon={<SvgIcon name="list" />} onClick={onExpand} />
                </Col>
                <Col flex={1} className={classes.titleContainer}>
                    <div className={classes.title}>{orderForm.name}</div>
                    <div className={classes.subtitle}>{vendor?.description}</div>
                </Col>
                <Col>
                    <Space>
                        <NotificationSetting
                            resourceId={orderFormId}
                            resourceType={ResourceType.OrderForm}
                            disabled={disabled}
                        />
                        <GroupSetting orderFormId={orderFormId} disabled={disabled} />
                        <Link to={`/supplier/${supplier?.id || ""}`}>
                            <Tooltip title="Go to buyer brief">
                                <SvgIcon name="briefs" />
                            </Tooltip>
                        </Link>
                        <Link to={`/order/score/${orderFormId}`}>
                            <Tooltip
                                title="Go to negotiation simulation"
                                placement="topRight"
                                arrowPointAtCenter={true}
                            >
                                <SvgIcon name="group" />
                            </Tooltip>
                        </Link>
                    </Space>
                </Col>
            </Row>
            <OrderFormTable orderForm={orderForm} onChange={onChange} disabled={disabled} />
        </GenericCard>
    );
};
